import React, { Component, Fragment } from "react";
import {
  FieldGroup,
  FieldControl,
  FormBuilder,
  Validators
} from "react-reactive-form";
import { Link } from "react-router-dom";
import { Auth } from "aws-amplify";
import { readableResponseMessage } from "ux-helpers";
import ResetPassword from "./ResetPassword";

export default class ForgotPassword extends Component {
  state = {
    emailAddress: "",
    resetPasswordRender: false
  };

  componentDidMount() {
    window.scrollTo({
      top: 400,
      behavior: 'smooth',
    })
  }

  handleSubmit = (e, form) => {
    e.preventDefault();
    this.resetPassword(form);
  };

  resetPassword = async form => {
    if (this.forgotPasswordForm.status === "VALID") {
      this.setState({ loadingBtn: true });
      this.forgotPasswordForm.handleSubmit();
      Auth.forgotPassword(form.emailAddress)
        .then(() => {
          this.setState({ emailAddress: form.emailAddress });
          this.setState({ resetPasswordRender: true });
        })
        .catch(error => {
          this.setState({
            loadingBtn: false,
            message: readableResponseMessage(error)
          });
          this.forgotPasswordForm.handleSubmit();
        });
    } else {
      this.forgotPasswordForm.handleSubmit();
    }
  };

  forgotPasswordForm = FormBuilder.group({
    emailAddress: ["", [Validators.required, Validators.email]]
  });

  render() {
    return (
      <div className="row center justify-content-center">
        {!this.state.resetPasswordRender ? (
          <div className="col-md-6 col-sm-12">
            <h2>Forgot your password?</h2>
            <p>
              Enter your email address below and we&#39;ll send your password
              reset instructions.
            </p>
            {this.state.message ? (
              <p className="error">{this.state.message}</p>
            ) : (
              ""
            )}
            <div>
              <Fragment>
                <FieldGroup
                  control={this.forgotPasswordForm}
                  render={({ value, submitted }) => (
                    <form
                      name="Forgot Password"
                      id="forgot-password-form"
                      onSubmit={e => this.handleSubmit(e, value)}
                      autoComplete="off"
                    >
                      <FieldControl
                        name="emailAddress"
                        render={({ handler, touched, hasError, pristine }) => (
                          <div className="inputContainer">
                            <input
                              className="form-control"
                              type="email"
                              {...handler()}
                            />
                            <label
                              htmlFor="emailAddress"
                              className={`label ${pristine ? "" : "notEmpty"}`}
                            >
                              Email Address
                              <span className="error">
                                {(touched || submitted) &&
                                  hasError("required") &&
                                  " - Required"}
                                {(touched || submitted) &&
                                  hasError("email") &&
                                  " - Required"}
                              </span>
                            </label>
                          </div>
                        )}
                      />
                      <button
                        className={`${
                          this.state.loadingBtn ? "btn-text-hide" : ""
                        }`}
                        type="submit"
                        disabled={this.state.loadingBtn}
                      >
                        Submit
                        <span
                          className={`${this.state.loadingBtn ? "loader" : ""}`}
                        />
                      </button>
                    </form>
                  )}
                />
                <p>
                  Back to <Link to="/"> Sign In </Link>
                </p>
              </Fragment>
            </div>
          </div>
        ) : (
          <ResetPassword
            history={this.props.history}
            emailAddress={this.state.emailAddress}
          />
        )}
      </div>
    );
  }
}
